var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleTagManager(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 38.482l-6.945-6.953 14.919-15.07 7.073 7.07L23.48 38.483z",
    fill: "#8AB4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.532 8.537L16.46 1.464 1.466 16.458a4.997 4.997 0 00-.003 7.069l.003.003L16.46 38.524l6.937-6.969-11.33-11.551L23.531 8.537z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.526 16.459L23.532 1.464a5.001 5.001 0 00-7.073 7.071L31.46 23.53a5 5 0 007.072 0 5 5 0 000-7.072h-.007z",
    fill: "#8AB4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 40.003a4.956 4.956 0 100-9.912 4.956 4.956 0 000 9.912z",
    fill: "#246FDB"
  })));
}

export default __webpack_public_path__ + "./fonts/google-tag-manager.1552b5600c05c1db99d2115128a7970e.svg";
export { SvgGoogleTagManager as ReactComponent };